import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddHtmlDocZip = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  const [showFailedMessage, setShowFailedMessage] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    active: true,
  });
  const [file, setFile] = useState(null);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file change
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      setMessage("Failed: Missing authentication token.");
      setShowFailedMessage(true);
      return;
    }

    if (!file) {
      setMessage("Please select a file to upload.");
      setShowFailedMessage(true);
      return;
    }

    try {
      // Create FormData for multipart/form-data
      const formDataToSend = new FormData();
      formDataToSend.append("Name", formData.name);
      formDataToSend.append("Active", formData.active === "true" || formData.active === true);
      formDataToSend.append("File", file);

      const response = await axios.post(
        "https://api.dqr-display-tms.bonrix.in/api/HtmlDocZipOperation/Insert",
        formDataToSend,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            accept: "text/plain",
            // Note: Don't set Content-Type manually when using FormData
            // axios will automatically set it with the correct boundary
          },
        }
      );

      // Success from API
      if (response.data?.isresponse && response.data?.responsestatus === "SUCCESS") {
        setMessage("HTML Document Zip added successfully!");
        setShowFailedMessage(false);

        setTimeout(() => navigate("/htmldocziplist"), 2500);
        return;
      }

      // API returned fail (like: already exist)
      const errorMsg = response.data?.errormsg || "Failed to add HTML document zip.";
      setMessage(errorMsg);
      setShowFailedMessage(true);

    } catch (error) {
      // Error from server
      const errorMsg = 
        error.response?.data?.errormsg ||
        error.response?.data?.message ||
        error.message ||
        "Failed to add HTML document zip.";
      setMessage(errorMsg);
      setShowFailedMessage(true);
      console.error("Error adding HTML document zip:", error);
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <h1>Add HTML Document</h1>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="card card-info">
                <div className="card-header">
                  <h3 className="card-title">Add HTML Document</h3>
                </div>

                <div className="card-body">
                  <form id="add-items" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-sm-6">
                        <label>Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter name..."
                          required
                        />
                      </div>

                      <div className="col-sm-6">
                        <label>File (Zip)</label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".zip"
                          onChange={handleFileChange}
                          required
                        />
                        {file && (
                          <small className="text-muted">Selected: {file.name}</small>
                        )}
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm-6">
                        <label>Active</label>
                        <select
                          className="form-control"
                          name="active"
                          value={formData.active}
                          onChange={handleChange}
                        >
                          <option value={true}>Active</option>
                          <option value={false}>Deactive</option>
                        </select>
                      </div>
                    </div>

                    <button type="submit" className="btn btn-info mt-3">
                      Add
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Success / Fail Messages */}
      {message === "HTML Document Zip added successfully!" && (
        <SuccessMessage message={message} />
      )}

      {showFailedMessage && message && message !== "HTML Document Zip added successfully!" && (
        <FailedMessage message={message} />
      )}
    </>
  );
};

export default AddHtmlDocZip;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
